module.exports = __webpack_public_path__ + "img/hs_kyoto.91284188.png";